import { Agenda } from '@modules/columnSettings/_columnSettingsEnums';
import useColumnSettings from '@modules/columnSettings/_columnSettingsStore';
import { compose, withProps } from 'recompose';

const withColumns = (agenda: Agenda) =>
  compose(
    withProps(() => {
      const { columns } = useColumnSettings();
      return {
        columns: columns[agenda].filter(v => v.active)
      };
    })
  );

export default withColumns;



// WEBPACK FOOTER //
// ./src/components/hoc/withColumns/withColumns.ts